// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"c78777fa","511":"0442f057","754":"d832c135","767":"e9fa0735"}[chunkId] + ".chunk.js";
};